import React from "react";
import { Box, MainTitle } from "app/components/common";
import CommentBox from "app/scenes/FeedbackScreen/CommentBox";
import i18n from "@microdoing/shared/i18n";

const FreeAnswerSlide = ({ title, value, onValueChange }) => {
  const handleValueChange = text => {
    onValueChange(text);
  };

  return (
    <Box flex={1} width="100%">
      <MainTitle variant="l6-bold" textAlign="center">
        {title}
      </MainTitle>
      <Box marginTop="xm">
        <CommentBox
          autoFocus
          textIn
          style={styles.commentBox}
          value={value}
          onChangeText={handleValueChange}
          placeholder={i18n.t("your-answer")}
        />
      </Box>
    </Box>
  );
};

const styles = {
  commentBox: {
    width: "100%",
    padding: 10,
    minHeight: 200,
  },
};

export default FreeAnswerSlide;
